import React from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { BUTTON_AS_TYPE, VARIANT } from '@motorway/mw-highway-code/enums';

import { wordpressImgToImgixURL } from 'Utilities';
import { GUIDES_PATH } from 'Utilities/wordpress';

import { Content } from 'LegacySBCRA/Content/Content';
import { RelatedGuides } from 'Storybook/components/local/RelatedGuides';

import texts from '../../../../../texts.json';
import { RelatedGuidesContentType } from '../../Pages/CheckerPage/CheckerPage.helpers';
import { usePageRefEvents } from '../../Pages/CheckerRouter.utils';

import styles from './RelatedGuidesSection.scss';

const LocalT = new MDText(texts);

const t = (key: string, props?: { [key:string]: unknown }) => LocalT.translate(key, props) as string;

type EventsAnalytics = {
  onButtonClick: ({ label, url }: { label: string; url: string }) => void;
  onLoad: () => void;
}

type RelatedGuidesProps = {
  analyticsEvents: EventsAnalytics;
  guides: RelatedGuidesContentType;
  sectionTitle: string;
};

const ImgixWidth = 288;

export const RelatedGuidesSection = ({
  analyticsEvents,
  guides,
  sectionTitle,
}: RelatedGuidesProps) => {
  const { setRef } = usePageRefEvents({ onRefTrigger: analyticsEvents.onLoad });

  return (<div ref={(ref) => setRef(ref)} className={styles.component} data-testid='relatedGuides'>
    <Content className={styles.contentWrapper}>
      <h2 className={styles.relatedGuidesTitle}>{sectionTitle}</h2>
      <div className={styles.relatedGuidesBody}>
        {
          guides.map(({ description, thumbnail, title, url }) => (
            <RelatedGuides
              key={title}
              onClick={() => analyticsEvents.onButtonClick({ label: title, url })}
              {...{ description, title, url }}
              imgAlt={typeof thumbnail === 'string' ? '' : thumbnail?.alt}
              imgSrc={`${wordpressImgToImgixURL(typeof thumbnail === 'string' ? thumbnail : thumbnail?.url)}&w=${ImgixWidth}`}
              wrapperClassName={styles.relatedGuidesCard}
            />
          ))
        }
      </div>

      <Button
        as={BUTTON_AS_TYPE.ANCHOR}
        href={GUIDES_PATH}
        icon='chevron'
        label={t('motRelatedGuides.link')}
        variant={VARIANT.SECONDARY}
      />
    </Content>
  </div>);
};
